@if (control) {
  <div class="time-picker-container">
    <mat-form-field [ngClass]="{ 'w-45': true }">
      <mat-label>{{ control.caption | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'TIME.HOURS' | translate }}"
        type="number"
        min="0"
        [max]="is24HourFormat ? 24 : null"
        [(ngModel)]="hours"
        [readonly]="control.isReadonly ? true : null"
        [ngClass]="{ locked: control.isReadonly }"
        [required]="control.required ? true : null"
        (input)="onHourChange($event.target.value)"
        />
      </mat-form-field>
      <span class="time-picker-divider">
        @if (is24HourFormat) {
          <span>:</span>
        }
      </span>
      <mat-form-field [ngClass]="{ 'w-45': true }">
        <mat-label></mat-label>
        <input
          matInput
          placeholder="{{ 'TIME.MINUTES' | translate }}"
          type="number"
          min="0"
          [max]="is24HourFormat ? 60 : null"
          [(ngModel)]="minutes"
          [readonly]="control.isReadonly ? true : null"
          [ngClass]="{ locked: control.isReadonly }"
          [required]="control.required ? true : null"
          (input)="onMinuteChange($event.target.value)"
          />
        </mat-form-field>
        <div class="time-picker-info">
          @if (helpText) {
            <app-help-text [dataContext]="helpText"></app-help-text>
          }
          @if (errorMessage) {
            <mat-error>{{ errorMessage?.message | translate: errorMessage?.params }}</mat-error>
          }
        </div>
      </div>
    }
